require("core-js/modules/esnext.global-this.js");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("minimatch"), require("axios")) : "function" == typeof define && define.amd ? define(["exports", "react", "minimatch", "axios"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).Embed = {}, e.React, e.minimatch, e.axios);
}(this, function (e, t, r, n) {
  "use strict";

  function o(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var i = o(t),
      c = o(r),
      s = o(n),
      _u = function u() {
    return (_u = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) {
        for (var o in t = arguments[r]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  function a(e, t, r, n) {
    return new (r || (r = Promise))(function (o, i) {
      function c(e) {
        try {
          u(n.next(e));
        } catch (e) {
          i(e);
        }
      }

      function s(e) {
        try {
          u(n.throw(e));
        } catch (e) {
          i(e);
        }
      }

      function u(e) {
        var t;
        e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
          e(t);
        })).then(c, s);
      }

      u((n = n.apply(e, t || [])).next());
    });
  }

  function l(e, t) {
    var r,
        n,
        o,
        i,
        c = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
    return i = {
      next: s(0),
      throw: s(1),
      return: s(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
      return this;
    }), i;

    function s(i) {
      return function (s) {
        return function (i) {
          if (r) throw new TypeError("Generator is already executing.");

          for (; c;) {
            try {
              if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

              switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                case 0:
                case 1:
                  o = i;
                  break;

                case 4:
                  return c.label++, {
                    value: i[1],
                    done: !1
                  };

                case 5:
                  c.label++, n = i[1], i = [0];
                  continue;

                case 7:
                  i = c.ops.pop(), c.trys.pop();
                  continue;

                default:
                  if (!(o = c.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                    c = 0;
                    continue;
                  }

                  if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                    c.label = i[1];
                    break;
                  }

                  if (6 === i[0] && c.label < o[1]) {
                    c.label = o[1], o = i;
                    break;
                  }

                  if (o && c.label < o[2]) {
                    c.label = o[2], c.ops.push(i);
                    break;
                  }

                  o[2] && c.ops.pop(), c.trys.pop();
                  continue;
              }

              i = t.call(e, c);
            } catch (e) {
              i = [6, e], n = 0;
            } finally {
              r = o = 0;
            }
          }

          if (5 & i[0]) throw i[1];
          return {
            value: i[0] ? i[1] : void 0,
            done: !0
          };
        }([i, s]);
      };
    }
  }

  var d = [{
    provider_name: "YouTube",
    provider_url: "https://www.youtube.com/",
    endpoints: [{
      schemes: ["https://*.youtube.com/watch*", "https://*.youtube.com/v/*", "https://youtu.be/*"],
      url: "https://www.youtube.com/oembed",
      discovery: !0
    }]
  }, {
    provider_name: "Reddit",
    provider_url: "https://reddit.com/",
    endpoints: [{
      schemes: ["https://reddit.com/r/*/comments/*/*", "https://www.reddit.com/r/*/comments/*/*"],
      url: "https://www.reddit.com/oembed"
    }]
  }, {
    provider_name: "Flickr",
    provider_url: "https://www.flickr.com/",
    endpoints: [{
      schemes: ["http://*.flickr.com/photos/*", "http://flic.kr/p/*", "https://*.flickr.com/photos/*", "https://flic.kr/p/*"],
      url: "https://www.flickr.com/services/oembed/",
      discovery: !0
    }]
  }, {
    provider_name: "Vimeo",
    provider_url: "https://vimeo.com/",
    endpoints: [{
      schemes: ["https://vimeo.com/*", "https://vimeo.com/album/*/video/*", "https://vimeo.com/channels/*/*", "https://vimeo.com/groups/*/videos/*", "https://vimeo.com/ondemand/*/*", "https://player.vimeo.com/video/*"],
      url: "https://vimeo.com/api/oembed.{format}",
      discovery: !0
    }]
  }, {
    provider_name: "SoundCloud",
    provider_url: "http://soundcloud.com/",
    endpoints: [{
      schemes: ["http://soundcloud.com/*", "https://soundcloud.com/*", "https://soundcloud.app.goog.gl/*"],
      url: "https://soundcloud.com/oembed"
    }]
  }, {
    provider_name: "Twitter",
    provider_url: "http://www.twitter.com/",
    endpoints: [{
      schemes: ["https://twitter.com/*/status/*", "https://*.twitter.com/*/status/*", "https://twitter.com/*/moments/*", "https://*.twitter.com/*/moments/*"],
      url: "https://publish.twitter.com/oembed"
    }]
  }, {
    provider_name: "GIPHY",
    provider_url: "https://giphy.com",
    endpoints: [{
      schemes: ["https://giphy.com/gifs/*", "http://gph.is/*", "https://media.giphy.com/media/*/giphy.gif"],
      url: "https://giphy.com/services/oembed",
      discovery: !0
    }]
  }];

  function p(e, t, r) {
    return a(this, void 0, void 0, function () {
      var n, o, i, c, u, a, d;
      return l(this, function (l) {
        switch (l.label) {
          case 0:
            if (n = m(r.url, t), o = n.base_url, i = n.requestInterceptor, c = n.responceInterceptor, u = n.getResponce, !o) throw Error("Invalid url: cannot guess oembed endpoint");
            return "OVERRIDE" === o ? [2, null == u ? void 0 : u(r)] : (a = function (e, t) {
              e.endsWith("/") && (e = e.slice(0, -1));
              var r = /\{format\}/gi;
              e.match(r) && (e = e.replace(r, "json"));
              if (!t) return e;
              var n = /\{url\}/gi,
                  o = /\{raw_url\}/gi;
              if (t.match(o)) return t.replace(o, e);
              if (t.match(n)) return e = encodeURIComponent(e), t.replace(n, e);
              t.endsWith("/") && (t = t.slice(0, -1));
              return t + "/" + e;
            }(o, e), d = s.default.create(), i && d.interceptors.request.use(i), c && d.interceptors.response.use(c), [4, d.get(a, {
              params: r
            })]);

          case 1:
            return [2, l.sent().data];
        }
      });
    });
  }

  function m(e, t) {
    var r, n, o, i;
    return (t = t || d).forEach(function (t) {
      var s;
      t.endpoints.forEach(function (t) {
        (function (e, t) {
          var r = Boolean(t.find(function (t) {
            return c.default(e, t, {
              nocase: !0
            });
          }));
          return r || Boolean(t.find(function (t) {
            return c.default(e, t.replace(/\*/g, "**"), {
              nocase: !0
            });
          }));
        })(e, t.schemes) && (s = t);
      }), s && (r = s.url, n = t.requestInterceptor, o = t.responceInterceptor, i = t.getResponce);
    }), {
      base_url: r,
      requestInterceptor: n,
      responceInterceptor: o,
      getResponce: i
    };
  }

  function f(e, r, n) {
    var o = [];
    t.useEffect(function () {
      var t = document.createElement("div");
      return t.innerHTML = e, t.querySelectorAll("script").forEach(function (e) {
        var t = document.createElement("script");
        Array.from(e.attributes).forEach(function (e) {
          "id" !== e.nodeName && t.setAttribute(e.nodeName, e.nodeValue || "");
        }), t.innerHTML = e.innerHTML, Object.entries(r || {}).forEach(function (e) {
          var r = e[0],
              n = e[1];
          t.setAttribute(r, n);
        }), document.body.appendChild(t), o = o.concat(t);
      }), function () {
        o.forEach(function (e) {
          document.body.removeChild(e);
        }), o = [];
      };
    }, n || [e]);
  }

  e.default = function (e) {
    var r = e.url,
        n = e.proxy,
        o = e.style,
        c = e.options,
        s = e.providers,
        d = e.ImgComponent,
        m = e.LinkComponent,
        h = e.FallbackElement,
        v = e.LoadingFallbackElement,
        b = t.useState(void 0),
        w = b[0],
        y = b[1],
        _ = t.useState("idle"),
        g = _[0],
        E = _[1],
        k = t.useState(""),
        x = k[0],
        I = k[1];

    f(x, {
      defer: ""
    }), t.useEffect(function () {
      "idle" === g && function () {
        a(this, void 0, void 0, function () {
          var e, t;
          return l(this, function (o) {
            switch (o.label) {
              case 0:
                return o.trys.push([0, 2,, 3]), E("loading"), [4, p(n, s, _u(_u({
                  url: r,
                  maxwidth: 700,
                  maxheight: 500,
                  align: "center"
                }, c), {
                  format: "json"
                }))];

              case 1:
                if (!(e = o.sent())) throw Error("Nill embed responce");
                return E("done"), y(e), e.html && I(e.html), [3, 3];

              case 2:
                return t = o.sent(), console.error("Error", t), E("error"), [3, 3];

              case 3:
                return [2];
            }
          });
        });
      }();
    }, [g]);
    var q,
        S = i.default.createElement("a", {
      href: r,
      target: "_blank",
      rel: "nofollow noreferrer noopener"
    }, r);
    return w && !w.html && ("photo" === w.type ? q = d ? i.default.createElement(d, {
      responce: w
    }) : i.default.createElement("img", {
      alt: "",
      src: w.url
    }) : "link" === w.type && (q = m ? i.default.createElement(m, {
      responce: w
    }) : i.default.createElement("a", {
      href: r,
      target: "_blank",
      rel: "nofollow noreferrer noopener"
    }, r))), "loading" === g || "idle" === g ? v || S : "error" === g ? h || S : i.default.createElement("span", {
      style: o,
      className: "__embed __embed_column"
    }, q, x && i.default.createElement("span", {
      className: "__embed_column",
      dangerouslySetInnerHTML: {
        __html: x
      }
    }), i.default.createElement("style", null, ".__embed {\n    margin: auto;\n    width: 100%;\n    max-width: 700px;\n} \n.__embed iframe {\n    width: 100%;\n    margin: auto;\n}\n.__embed img, .__embed video {\n    width: 100%;\n    margin: 0;\n}\n.__embed blockquote {\n    margin: 0;\n}\n.__embed span {\n    border: 0;\n} \n.__embed_column {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}"));
  }, e.defaultProviders = d, e.getEndpoint = m, e.requestEmbed = p, e.useScript = f, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});